export default "__VITE_ASSET__78bab19d__"